import { ReactComponent } from "/builds/mb/front/src/app/assets/images/back.svg?react";
import url from "/builds/mb/front/src/app/assets/images/back.svg?url";
export { ReactComponent };
export default url;
